import Base from '../Pages/Base'
import ListCategorias from '../Pages/Categorias/List'
import FormCategorias from '../Pages/Categorias/Form'
import ListLicitacoes from '../Pages/Licitacoes/List'
import FormLicitacoes from '../Pages/Licitacoes/Form'
import ArquivosList from '../Pages/Arquivos/List'
import FormArquivos from '../Pages/Arquivos/Form'

export default [
	{
		path: 'servicos/licitacoes',
		component: Base,
		children: [
			{
				path: '',
				name: 'ListCategorias',
				component: ListCategorias,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'novo',
				name: 'FormCategorias',
				component: FormCategorias,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: false,
						url: '/servicos/licitacoes'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: 'editar/:id',
				name: 'FormCategoriasEditar',
				component: FormCategorias,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: false,
						url: '/servicos/licitacoes'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			
			{
				path: ':id',
				name: 'ListLicitacoes',
				component: ListLicitacoes,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: false,
						url: '/servicos/licitacoes'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado'
					}],
					noCache: true
				},
			},

			{
				path: ':id/novo',
				name: 'FormLicitacoes',
				component: FormLicitacoes,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: false,
						url: '/servicos/licitacoes'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':id/editar/:cat',
				name: 'FormLicitacoesEditar',
				component: FormLicitacoes,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: false,
						url: '/servicos/licitacoes'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':cat/:id',
				name: 'ArquivosList',
				component: ArquivosList,
				props: true,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: false,
						url: '/servicos/licitacoes'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: false,
						newClass: 'menu-selecionado-cat',
					}],
					noCache: true
				},
			},

			{
				path: ':cat/:id/novo',
				name: 'FormArquivos',
				component: FormArquivos,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: false,
						url: '/servicos/licitacoes'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: '/',
						ref: 'menuSelecionado2'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			{
				path: ':cat/:id/editar/:arq',
				name: 'FormArquivosEditar',
				component: FormArquivos,
				meta: {
					path: '/servicos/licitacoes',
					pai: 'Serviços',
					title: 'Admin - Licitações - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Licitações',
						class: '',
						active: false,
						url: '/servicos/licitacoes'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: false,
						url: '/',
						ref: 'menuSelecionado'
					},
					{
						pagina: 'Carregando...',
						class: '',
						active: true,
						url: '/',
						ref: 'menuSelecionado2'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},

			
		]
	}
]